import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

// Template 1: Newspaper Layout
const Template1 = ({ formData, imagePreview, currencyOptions }) => {
  const getCurrencySymbol = (code) => {
    const currency = currencyOptions.find(c => c.code === code);
    return currency ? currency.symbol : code;
  };

  return (
    <div style={{ 
      padding: '40px', 
      maxWidth: '1000px', 
      margin: '0 auto', 
      backgroundColor: '#ffffff', 
      fontFamily: "'Times New Roman', Georgia, serif",
      color: '#000000'
    }}>
      {/* Newspaper Header */}
      <div style={{ textAlign: 'center', borderBottom: '3px double #000', paddingBottom: '16px', marginBottom: '24px' }}>
        <div style={{ fontSize: '12px', letterSpacing: '6px', textTransform: 'uppercase', marginBottom: '4px', color: '#333' }}>
          The Travel Times
        </div>
        <div style={{ fontSize: '10px', color: '#666' }}>✦ Premium Travel Edition ✦</div>
      </div>

      {/* Headline */}
      <div style={{ textAlign: 'center', marginBottom: '24px' }}>
        <h1 style={{ fontSize: '34px', fontWeight: 'bold', margin: '0 0 4px 0' }}>
          {formData.Title || 'Untitled Package'}
        </h1>
        <p style={{ fontSize: '16px', color: '#444', fontStyle: 'italic', margin: '0' }}>
          {formData.Description || 'No description provided'}
        </p>
      </div>

      {/* Image & Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: '24px' }}>
        <div>
          {imagePreview && (
            <img src={imagePreview} alt="Package" style={{ width: '100%', maxHeight: '300px', objectFit: 'cover', border: '1px solid #ddd' }} />
          )}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
          <div style={{ padding: '12px', border: '1px solid #ddd' }}>
            <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Duration</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{formData.Duration || `${formData.TotalDays}D/${formData.TotalNights}N`}</div>
          </div>
          <div style={{ padding: '12px', border: '1px solid #ddd' }}>
            <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Destinations</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{formData.DestinationsCover || 'N/A'}</div>
          </div>
          <div style={{ padding: '12px', border: '1px solid #ddd' }}>
            <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Travelers</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{(formData.Adults || 0) + (formData.Kids || 0) + (formData.Infants || 0)}</div>
          </div>
          {/* <div style={{ padding: '12px', border: '1px solid #ddd' }}>
            <div style={{ fontSize: '10px, textTransform: 'uppercase', color: '#666' }}>Price</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{getCurrencySymbol(formData.Currency)}{formData.SalePrice || 0}</div>
          </div> */}
        </div>
      </div>

      {/* Article Layout */}
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '30px', marginBottom: '24px' }}>
        <div>
          <div style={{ fontSize: '16px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '12px' }}>
            Itinerary
          </div>
          {formData.Itinerary.map((day, idx) => (
            <div key={idx} style={{ marginBottom: '12px', padding: '12px', borderBottom: '1px dotted #ddd' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <strong style={{ fontSize: '14px' }}>Day {day.Day || idx + 1}</strong>
                <span style={{ fontSize: '12px', color: '#666' }}>{day.Location || ''}</span>
              </div>
              <div style={{ fontSize: '14px', fontWeight: '500' }}>{day.Title || ''}</div>
              <p style={{ fontSize: '13px', color: '#555', margin: '4px 0 0 0' }}>{day.Description || ''}</p>
            </div>
          ))}
        </div>

        <div>
          <div style={{ marginTop: '16px' }}>
            <div style={{ fontSize: '16px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '12px' }}>
              Price Breakdown
            </div>
            <div style={{ fontSize: '13px', lineHeight: '2' }}>
              <div>Flight: {getCurrencySymbol(formData.Currency)}{formData.FlightPrice || 0}</div>
              <div>Hotel: {getCurrencySymbol(formData.Currency)}{formData.HotelPrice || 0}</div>
              <div>Sightseeing: {getCurrencySymbol(formData.Currency)}{formData.SightSeeingPrice || 0}</div>
              <div>Transfers: {getCurrencySymbol(formData.Currency)}{formData.TransferPrice || 0}</div>
              <div>Other: {getCurrencySymbol(formData.Currency)}{formData.OtherPrice || 0}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Sections */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', borderTop: '1px solid #ddd', paddingTop: '20px' }}>
        <div>
          <div style={{ fontSize: '15px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '8px' }}>Inclusions</div>
          <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '13px' }}>
            {formData.Inclusions.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>
        <div>
          <div style={{ fontSize: '15px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '8px' }}>Exclusions</div>
          <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '13px' }}>
            {formData.Exclusions.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>
      </div>

      {/* Contact */}
      <div style={{ marginTop: '20px', padding: '16px', border: '1px solid #ddd' }}>
        <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>Contact</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', fontSize: '13px' }}>
          <div><strong>Name:</strong> {formData.ContactName || 'N/A'}</div>
          <div><strong>Phone:</strong> {formData.ContactPhoneNumber || 'N/A'}</div>
          <div><strong>Email:</strong> {formData.ContactEmail || 'N/A'}</div>
        </div>
      </div>
    </div>
  );
};

// Template 2: Formal Document
const Template2 = ({ formData, imagePreview, currencyOptions }) => {
  const getCurrencySymbol = (code) => {
    const currency = currencyOptions.find(c => c.code === code);
    return currency ? currency.symbol : code;
  };

  return (
    <div style={{ 
      padding: '50px', 
      maxWidth: '900px', 
      margin: '0 auto', 
      backgroundColor: '#ffffff', 
      fontFamily: "'Helvetica Neue', Arial, sans-serif",
      color: '#000000'
    }}>
      {/* Letterhead */}
      <div style={{ textAlign: 'center', borderBottom: '2px solid #000', paddingBottom: '20px', marginBottom: '30px' }}>
        <h1 style={{ fontSize: '24px', fontWeight: '300', margin: '0', letterSpacing: '3px' }}>
          TRAVEL PACKAGE DOCUMENT
        </h1>
      
      </div>

      {/* Title */}
      <div style={{ marginBottom: '24px' }}>
        <h2 style={{ fontSize: '22px', fontWeight: 'bold', margin: '0' }}>{formData.Title || 'Untitled Package'}</h2>
        <p style={{ fontSize: '14px', color: '#444', margin: '4px 0 0 0' }}>{formData.Description || 'No description provided'}</p>
      </div>

      {imagePreview && (
        <div style={{ marginBottom: '24px', textAlign: 'center' }}>
          <img src={imagePreview} alt="Package" style={{ maxWidth: '100%', maxHeight: '250px', objectFit: 'contain', border: '1px solid #ddd' }} />
        </div>
      )}

      {/* Summary Table */}
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '24px', fontSize: '13px' }}>
        <tbody>
          <tr>
            <td style={{ padding: '8px', border: '1px solid #000', fontWeight: 'bold', width: '15%' }}>Duration</td>
            <td style={{ padding: '8px', border: '1px solid #000', width: '35%' }}>{formData.Duration || `${formData.TotalDays}D/${formData.TotalNights}N`}</td>
            <td style={{ padding: '8px', border: '1px solid #000', fontWeight: 'bold', width: '15%' }}>Destinations</td>
            <td style={{ padding: '8px', border: '1px solid #000', width: '35%' }}>{formData.DestinationsCover || 'N/A'}</td>
          </tr>
          <tr>
            <td style={{ padding: '8px', border: '1px solid #000', fontWeight: 'bold' }}>Travel Type</td>
            <td style={{ padding: '8px', border: '1px solid #000' }}>{formData.TravelType || 'N/A'}</td>
        <td style={{ padding: '8px', border: '1px solid #000', fontWeight: 'bold' }}>Travelers</td>
            <td style={{ padding: '8px', border: '1px solid #000' }}>{formData.Adults || 0} Adults, {formData.Kids || 0} Kids, {formData.Infants || 0} Infants</td>
          
          </tr>
      
            
        
          <tr>
            <td style={{ padding: '8px', border: '1px solid #000', fontWeight: 'bold' }}>Total Price</td>
            <td style={{ padding: '8px', border: '1px solid #000', fontWeight: 'bold' }}>{getCurrencySymbol(formData.Currency)}{formData.SalePrice || 0}</td>
           

          </tr>
        </tbody>
      </table>

      {/* Itinerary */}
      <div style={{ marginBottom: '24px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: 'bold', borderBottom: '2px solid #000', paddingBottom: '4px', marginBottom: '12px' }}>
          Itinerary
        </h3>
        {formData.Itinerary.map((day, idx) => (
          <div key={idx} style={{ 
            marginBottom: '8px', 
            padding: '8px 12px',
            borderLeft: '3px solid #000'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <strong>Day {day.Day || idx + 1}</strong>
              <span>{day.Location || ''}</span>
            </div>
            <div>{day.Title || ''}</div>
            <div style={{ fontSize: '12px', color: '#555' }}>{day.Description || ''}</div>
          </div>
        ))}
      </div>

      {/* Two Column */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: '24px' }}>
        <div>
          <h3 style={{ fontSize: '14px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '8px' }}>
            Inclusions
          </h3>
          <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '13px' }}>
            {formData.Inclusions.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>
        <div>
          <h3 style={{ fontSize: '14px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '8px' }}>
            Exclusions
          </h3>
          <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '13px' }}>
            {formData.Exclusions.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>
      </div>

      {/* Terms */}
      {formData.Terms.length > 0 && (
        <div style={{ marginBottom: '24px' }}>
          <h3 style={{ fontSize: '14px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '8px' }}>
            Terms & Conditions
          </h3>
          {formData.Terms.map((term, idx) => (
            <div key={idx} style={{ marginBottom: '4px', fontSize: '13px' }}>
              <strong>{term.Title}</strong>
              {term.Description && <span style={{ color: '#555' }}> - {term.Description}</span>}
            </div>
          ))}
        </div>
      )}

      {/* Contact */}
      <div style={{ padding: '16px', border: '1px solid #000' }}>
        <h3 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>Contact Information</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', fontSize: '13px' }}>
          <div><strong>Name:</strong> {formData.ContactName || 'N/A'}</div>
          <div><strong>Phone:</strong> {formData.ContactPhoneNumber || 'N/A'}</div>
          <div><strong>Email:</strong> {formData.ContactEmail || 'N/A'}</div>
        </div>
      </div>
    </div>
  );
};

// Template 3: Magazine Style
const Template3 = ({ formData, imagePreview, currencyOptions }) => {
  const getCurrencySymbol = (code) => {
    const currency = currencyOptions.find(c => c.code === code);
    return currency ? currency.symbol : code;
  };

  return (
    <div style={{ 
      padding: '40px', 
      maxWidth: '1000px', 
      margin: '0 auto', 
      backgroundColor: '#f9f9f9', 
      fontFamily: "'Georgia', serif",
      color: '#000000'
    }}>
      <div style={{ backgroundColor: '#ffffff', padding: '40px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
        {/* Feature Image */}
        {imagePreview && (
          <div style={{ marginBottom: '24px' }}>
            <img src={imagePreview} alt="Package" style={{ width: '100%', maxHeight: '350px', objectFit: 'cover' }} />
          </div>
        )}

        {/* Title */}
        <h1 style={{ fontSize: '32px', fontWeight: 'bold', margin: '0 0 4px 0' }}>
          {formData.Title || 'Untitled Package'}
        </h1>
        <p style={{ fontSize: '16px', color: '#555', margin: '0 0 16px 0', fontStyle: 'italic' }}>
          {formData.Description || 'No description provided'}
        </p>

        {/* Stats Bar */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(4, 1fr)', 
          gap: '8px',
          marginBottom: '24px',
          padding: '16px',
          border: '1px solid #ddd'
        }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Duration</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{formData.Duration || `${formData.TotalDays}D/${formData.TotalNights}N`}</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Destinations</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{formData.DestinationsCover || 'N/A'}</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Travelers</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{(formData.Adults || 0) + (formData.Kids || 0) + (formData.Infants || 0)}</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Price</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{getCurrencySymbol(formData.Currency)}{formData.SalePrice || 0}</div>
          </div>
        </div>

        {/* Main Content */}
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '30px' }}>
          <div>
            <h2 style={{ fontSize: '18px', fontWeight: 'bold', borderBottom: '2px solid #000', paddingBottom: '6px', marginBottom: '16px' }}>
              Itinerary
            </h2>
            {formData.Itinerary.map((day, idx) => (
              <div key={idx} style={{ 
                marginBottom: '12px', 
                padding: '12px',
                border: '1px solid #eee'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <h3 style={{ margin: '0', fontSize: '15px' }}>Day {day.Day || idx + 1}</h3>
                  <span style={{ fontSize: '13px', color: '#666' }}>{day.Location || ''}</span>
                </div>
                <h4 style={{ margin: '4px 0', fontSize: '14px' }}>{day.Title || ''}</h4>
                <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#444' }}>{day.Description || ''}</p>
              </div>
            ))}
          </div>

          <div>
            <div style={{ padding: '16px', border: '1px solid #ddd', marginBottom: '16px' }}>
              <h3 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>Package Details</h3>
              <div style={{ fontSize: '13px', lineHeight: '1.8' }}>
                <div><strong>Travel Type:</strong> {formData.TravelType || 'N/A'}</div>
               
              </div>
            </div>

            <div style={{ padding: '16px', border: '1px solid #ddd', marginBottom: '16px' }}>
              <h3 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>Price Breakdown</h3>
              <div style={{ fontSize: '13px', lineHeight: '1.8' }}>
                <div>Flight: {getCurrencySymbol(formData.Currency)}{formData.FlightPrice || 0}</div>
                <div>Hotel: {getCurrencySymbol(formData.Currency)}{formData.HotelPrice || 0}</div>
                <div>Sightseeing: {getCurrencySymbol(formData.Currency)}{formData.SightSeeingPrice || 0}</div>
                <div>Transfers: {getCurrencySymbol(formData.Currency)}{formData.TransferPrice || 0}</div>
                <div>Other: {getCurrencySymbol(formData.Currency)}{formData.OtherPrice || 0}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Inclusions & Exclusions */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginTop: '24px', borderTop: '1px solid #ddd', paddingTop: '24px' }}>
          <div>
            <h3 style={{ fontSize: '15px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '8px' }}>
              Inclusions
            </h3>
            <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '13px' }}>
              {formData.Inclusions.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          </div>
          <div>
            <h3 style={{ fontSize: '15px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '8px' }}>
              Exclusions
            </h3>
            <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '13px' }}>
              {formData.Exclusions.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          </div>
        </div>

        {/* Contact */}
        <div style={{ marginTop: '24px', padding: '16px', border: '1px solid #000' }}>
          <h3 style={{ fontSize: '15px', fontWeight: 'bold', marginBottom: '8px' }}>Contact</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', fontSize: '13px' }}>
            <div><strong>Name:</strong> {formData.ContactName || 'N/A'}</div>
            <div><strong>Phone:</strong> {formData.ContactPhoneNumber || 'N/A'}</div>
            <div><strong>Email:</strong> {formData.ContactEmail || 'N/A'}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Template 4: Minimalist Card
const Template4 = ({ formData, imagePreview, currencyOptions }) => {
  const getCurrencySymbol = (code) => {
    const currency = currencyOptions.find(c => c.code === code);
    return currency ? currency.symbol : code;
  };

  return (
    <div style={{ 
      padding: '30px', 
      maxWidth: '1000px', 
      margin: '0 auto', 
      backgroundColor: '#ffffff', 
      fontFamily: "'Helvetica', Arial, sans-serif",
      color: '#000000'
    }}>
      {/* Header Card */}
      <div style={{ 
        border: '1px solid #ddd', 
        padding: '24px', 
        marginBottom: '24px',
        display: 'grid',
        gridTemplateColumns: 'auto 1fr auto',
        gap: '20px',
        alignItems: 'center'
      }}>
        {imagePreview && (
          <div style={{ width: '100px', height: '100px', overflow: 'hidden' }}>
            <img src={imagePreview} alt="Package" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
        )}
        <div>
          <h1 style={{ fontSize: '24px', fontWeight: 'bold', margin: '0' }}>{formData.Title || 'Untitled Package'}</h1>
          <p style={{ fontSize: '14px', color: '#555', margin: '4px 0 0 0' }}>{formData.Description || 'No description provided'}</p>
        </div>
        <div style={{ textAlign: 'right', padding: '12px 16px', border: '2px solid #000' }}>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', color: '#666' }}>Price</div>
          <div style={{ fontSize: '22px', fontWeight: 'bold' }}>{getCurrencySymbol(formData.Currency)}{formData.SalePrice || 0}</div>
        </div>
      </div>

      {/* Stats Cards */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(4, 1fr)', 
        gap: '12px',
        marginBottom: '24px'
      }}>
        <div style={{ padding: '16px', border: '1px solid #ddd' }}>
          <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Duration</div>
          <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{formData.Duration || `${formData.TotalDays}D/${formData.TotalNights}N`}</div>
        </div>
        <div style={{ padding: '16px', border: '1px solid #ddd' }}>
          <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Destinations</div>
          <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{formData.DestinationsCover || 'N/A'}</div>
        </div>
        <div style={{ padding: '16px', border: '1px solid #ddd' }}>
          <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Travelers</div>
          <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{(formData.Adults || 0) + (formData.Kids || 0) + (formData.Infants || 0)}</div>
        </div>
       
      </div>

      {/* Main Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '24px' }}>
        <div>
          <div style={{ border: '1px solid #ddd', padding: '20px', marginBottom: '20px' }}>
            <h2 style={{ fontSize: '16px', fontWeight: 'bold', borderBottom: '2px solid #000', paddingBottom: '6px', marginBottom: '16px' }}>
              Itinerary
            </h2>
            {formData.Itinerary.map((day, idx) => (
              <div key={idx} style={{ 
                padding: '10px 0', 
                borderBottom: '1px solid #eee',
                display: 'grid',
                gridTemplateColumns: '60px 1fr',
                gap: '12px'
              }}>
                <div style={{ fontWeight: 'bold' }}>Day {day.Day || idx + 1}</div>
                <div>
                  <div style={{ fontWeight: '500' }}>{day.Title || ''}</div>
                  <div style={{ fontSize: '12px', color: '#555' }}>{day.Description || ''}</div>
                  {day.Location && <div style={{ fontSize: '11px', color: '#777' }}>📍 {day.Location}</div>}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div style={{ border: '1px solid #ddd', padding: '20px', marginBottom: '20px' }}>
            <h3 style={{ fontSize: '14px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '12px' }}>
              Details
            </h3>
            <div style={{ fontSize: '13px', lineHeight: '1.8' }}>
              <div><strong>Travel Type:</strong> {formData.TravelType || 'N/A'}</div>
              <div><strong>Adults:</strong> {formData.Adults || 0}</div>
              <div><strong>Kids:</strong> {formData.Kids || 0}</div>
              <div><strong>Infants:</strong> {formData.Infants || 0}</div>
            </div>
          </div>

          <div style={{ border: '1px solid #ddd', padding: '20px', marginBottom: '20px' }}>
            <h3 style={{ fontSize: '14px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '12px' }}>
              Inclusions
            </h3>
            <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '13px' }}>
              {formData.Inclusions.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          </div>

          <div style={{ border: '1px solid #ddd', padding: '20px' }}>
            <h3 style={{ fontSize: '14px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '12px' }}>
              Exclusions
            </h3>
            <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '13px' }}>
              {formData.Exclusions.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          </div>
        </div>
      </div>

      {/* Contact */}
      <div style={{ marginTop: '24px', border: '1px solid #ddd', padding: '16px' }}>
        <h3 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>Contact</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', fontSize: '13px' }}>
          <div><strong>Name:</strong> {formData.ContactName || 'N/A'}</div>
          <div><strong>Phone:</strong> {formData.ContactPhoneNumber || 'N/A'}</div>
          <div><strong>Email:</strong> {formData.ContactEmail || 'N/A'}</div>
        </div>
      </div>
    </div>
  );
};

// Template 5: Elegant Classic
const Template5 = ({ formData, imagePreview, currencyOptions }) => {
  const getCurrencySymbol = (code) => {
    const currency = currencyOptions.find(c => c.code === code);
    return currency ? currency.symbol : code;
  };

  return (
    <div style={{ 
      padding: '50px', 
      maxWidth: '900px', 
      margin: '0 auto', 
      backgroundColor: '#ffffff', 
      fontFamily: "'Palatino', 'Georgia', serif",
      color: '#000000'
    }}>
      {/* Decorative Header */}
      <div style={{ textAlign: 'center', borderBottom: '1px solid #000', paddingBottom: '20px', marginBottom: '30px' }}>
        <div style={{ fontSize: '11px', letterSpacing: '4px', textTransform: 'uppercase', color: '#444' }}>
          ✦ Exclusive Travel Experience ✦
        </div>
        <h1 style={{ fontSize: '30px', fontWeight: 'normal', margin: '8px 0 4px 0', letterSpacing: '1px' }}>
          {formData.Title || 'Untitled Package'}
        </h1>
        <p style={{ fontSize: '15px', color: '#444', margin: '0', fontStyle: 'italic' }}>
          {formData.Description || 'No description provided'}
        </p>
      </div>

      {imagePreview && (
        <div style={{ marginBottom: '24px', textAlign: 'center' }}>
          <img src={imagePreview} alt="Package" style={{ maxWidth: '100%', maxHeight: '300px', objectFit: 'contain', border: '1px solid #ddd' }} />
        </div>
      )}

      {/* Info Grid */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: '1fr 1fr 1fr 1fr', 
        gap: '8px',
        marginBottom: '30px',
        padding: '16px',
        border: '1px solid #ddd'
      }}>
        <div>
          <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Duration</div>
          <div style={{ fontSize: '17px' }}>{formData.Duration || `${formData.TotalDays}D/${formData.TotalNights}N`}</div>
        </div>
        <div>
          <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Destinations</div>
          <div style={{ fontSize: '17px' }}>{formData.DestinationsCover || 'N/A'}</div>
        </div>
        <div>
          <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Travelers</div>
          <div style={{ fontSize: '17px' }}>{(formData.Adults || 0) + (formData.Kids || 0) + (formData.Infants || 0)}</div>
        </div>
        <div>
          <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Price</div>
          <div style={{ fontSize: '17px', fontWeight: 'bold' }}>{getCurrencySymbol(formData.Currency)}{formData.SalePrice || 0}</div>
        </div>
      </div>

      {/* Details Row */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: '1fr 1fr 1fr', 
        gap: '16px',
        marginBottom: '24px',
        padding: '12px 16px',
        border: '1px solid #ddd'
      }}>
        <div><strong>Travel Type:</strong> {formData.TravelType || 'N/A'}</div>
       
      </div>

      {/* Itinerary */}
      <div style={{ marginBottom: '24px' }}>
        <h2 style={{ fontSize: '18px', fontWeight: 'bold', borderBottom: '2px solid #000', paddingBottom: '6px', marginBottom: '16px' }}>
          Itinerary
        </h2>
        {formData.Itinerary.map((day, idx) => (
          <div key={idx} style={{ 
            marginBottom: '12px', 
            padding: '12px 16px',
            border: '1px solid #eee'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
              <strong>Day {day.Day || idx + 1}</strong>
              <span style={{ color: '#555' }}>{day.Location || ''}</span>
            </div>
            <div style={{ fontWeight: '500' }}>{day.Title || ''}</div>
            <div style={{ fontSize: '13px', color: '#444', marginTop: '4px' }}>{day.Description || ''}</div>
          </div>
        ))}
      </div>

      {/* Inclusions & Exclusions */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: '24px' }}>
        <div>
          <h3 style={{ fontSize: '15px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '8px' }}>
            Inclusions
          </h3>
          <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '13px' }}>
            {formData.Inclusions.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>
        <div>
          <h3 style={{ fontSize: '15px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '8px' }}>
            Exclusions
          </h3>
          <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '13px' }}>
            {formData.Exclusions.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>
      </div>

      {/* Terms */}
      {formData.Terms.length > 0 && (
        <div style={{ marginBottom: '24px' }}>
          <h3 style={{ fontSize: '15px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '8px' }}>
            Terms & Conditions
          </h3>
          {formData.Terms.map((term, idx) => (
            <div key={idx} style={{ marginBottom: '4px', fontSize: '13px' }}>
              <strong>{term.Title}</strong>
              {term.Description && <span style={{ color: '#555' }}> - {term.Description}</span>}
            </div>
          ))}
        </div>
      )}

      {/* Contact */}
      <div style={{ padding: '16px', border: '2px solid #000' }}>
        <h3 style={{ fontSize: '15px', fontWeight: 'bold', marginBottom: '8px' }}>Contact Information</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', fontSize: '13px' }}>
          <div><strong>Name:</strong> {formData.ContactName || 'N/A'}</div>
          <div><strong>Phone:</strong> {formData.ContactPhoneNumber || 'N/A'}</div>
          <div><strong>Email:</strong> {formData.ContactEmail || 'N/A'}</div>
        </div>
      </div>
    </div>
  );
};

// Template 6: Structured Grid
const Template6 = ({ formData, imagePreview, currencyOptions }) => {
  const getCurrencySymbol = (code) => {
    const currency = currencyOptions.find(c => c.code === code);
    return currency ? currency.symbol : code;
  };

  return (
    <div style={{ 
      padding: '30px', 
      maxWidth: '1100px', 
      margin: '0 auto', 
      backgroundColor: '#ffffff', 
      fontFamily: "'Segoe UI', Arial, sans-serif",
      color: '#000000'
    }}>
      {/* Header */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'auto 1fr auto', 
        gap: '20px',
        padding: '20px',
        border: '1px solid #ddd',
        marginBottom: '24px'
      }}>
        {imagePreview && (
          <div style={{ width: '80px', height: '80px', overflow: 'hidden' }}>
            <img src={imagePreview} alt="Package" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
        )}
        <div>
          <h1 style={{ fontSize: '22px', fontWeight: 'bold', margin: '0' }}>{formData.Title || 'Untitled Package'}</h1>
          <p style={{ fontSize: '13px', color: '#555', margin: '4px 0 0 0' }}>{formData.Description || 'No description provided'}</p>
          <div style={{ display: 'flex', gap: '8px', marginTop: '6px', flexWrap: 'wrap', fontSize: '12px' }}>
            <span style={{ padding: '2px 8px', border: '1px solid #ddd' }}>{formData.TravelType || 'N/A'}</span>
            
          </div>
        </div>
        <div style={{ textAlign: 'right', padding: '8px 16px', border: '2px solid #000' }}>
          <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Price</div>
          <div style={{ fontSize: '22px', fontWeight: 'bold' }}>{getCurrencySymbol(formData.Currency)}{formData.SalePrice || 0}</div>
        </div>
      </div>

      {/* Stats Grid */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(4, 1fr)', 
        gap: '12px',
        marginBottom: '24px'
      }}>
        <div style={{ padding: '12px', border: '1px solid #ddd' }}>
          <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Duration</div>
          <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{formData.Duration || `${formData.TotalDays}D/${formData.TotalNights}N`}</div>
        </div>
        <div style={{ padding: '12px', border: '1px solid #ddd' }}>
          <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Destinations</div>
          <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{formData.DestinationsCover || 'N/A'}</div>
        </div>
        <div style={{ padding: '12px', border: '1px solid #ddd' }}>
          <div style={{ fontSize: '10px', textTransform: 'uppercase', color: '#666' }}>Travelers</div>
          <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{(formData.Adults || 0) + (formData.Kids || 0) + (formData.Infants || 0)}</div>
        </div>
      
      </div>

      {/* Main Content */}
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '24px' }}>
        <div>
          <div style={{ border: '1px solid #ddd', padding: '16px', marginBottom: '16px' }}>
            <h2 style={{ fontSize: '16px', fontWeight: 'bold', borderBottom: '2px solid #000', paddingBottom: '6px', marginBottom: '12px' }}>
              Itinerary
            </h2>
            {formData.Itinerary.map((day, idx) => (
              <div key={idx} style={{ 
                padding: '8px 0', 
                borderBottom: '1px solid #eee',
                display: 'grid',
                gridTemplateColumns: '50px 1fr',
                gap: '12px'
              }}>
                <div style={{ fontWeight: 'bold' }}>Day {day.Day || idx + 1}</div>
                <div>
                  <div>{day.Title || ''}</div>
                  <div style={{ fontSize: '12px', color: '#555' }}>{day.Description || ''}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={{ border: '1px solid #ddd', padding: '16px' }}>
            <h3 style={{ fontSize: '14px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '8px' }}>
              Contact
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '8px', fontSize: '13px' }}>
              <div><strong>Name:</strong> {formData.ContactName || 'N/A'}</div>
              <div><strong>Phone:</strong> {formData.ContactPhoneNumber || 'N/A'}</div>
              <div><strong>Email:</strong> {formData.ContactEmail || 'N/A'}</div>
            </div>
          </div>
        </div>

        <div>
          <div style={{ border: '1px solid #ddd', padding: '16px', marginBottom: '16px' }}>
            <h3 style={{ fontSize: '14px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '8px' }}>
              Travelers
            </h3>
            <div style={{ fontSize: '13px', lineHeight: '1.8' }}>
              <div><strong>Adults:</strong> {formData.Adults || 0}</div>
              <div><strong>Kids:</strong> {formData.Kids || 0}</div>
              <div><strong>Infants:</strong> {formData.Infants || 0}</div>
            </div>
          </div>

          <div style={{ border: '1px solid #ddd', padding: '16px', marginBottom: '16px' }}>
            <h3 style={{ fontSize: '14px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '8px' }}>
              Price Breakdown
            </h3>
            <div style={{ fontSize: '13px', lineHeight: '1.8' }}>
              <div>Flight: {getCurrencySymbol(formData.Currency)}{formData.FlightPrice || 0}</div>
              <div>Hotel: {getCurrencySymbol(formData.Currency)}{formData.HotelPrice || 0}</div>
              <div>Sightseeing: {getCurrencySymbol(formData.Currency)}{formData.SightSeeingPrice || 0}</div>
              <div>Transfers: {getCurrencySymbol(formData.Currency)}{formData.TransferPrice || 0}</div>
              <div>Other: {getCurrencySymbol(formData.Currency)}{formData.OtherPrice || 0}</div>
            </div>
          </div>

          <div style={{ border: '1px solid #ddd', padding: '16px' }}>
            <h3 style={{ fontSize: '14px', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '8px' }}>
              Inclusions
            </h3>
            <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '12px' }}>
              {formData.Inclusions.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

// Main Preview Page Component
const PackagePreviewPage = () => {
  const location = useLocation();
  const [previewData, setPreviewData] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(1);
  const [isDownloading, setIsDownloading] = useState(false);
  const previewRef = useRef(null);

  const templates = [
    { id: 1, name: 'Newspaper Layout', component: Template1 },
    { id: 2, name: 'Formal Document', component: Template2 },
    { id: 3, name: 'Magazine Style', component: Template3 },
    { id: 4, name: 'Minimalist Card', component: Template4 },
    { id: 5, name: 'Elegant Classic', component: Template5 },
    { id: 6, name: 'Structured Grid', component: Template6 },
  ];

  useEffect(() => {
    const data = sessionStorage.getItem('previewData');
    if (data) {
      setPreviewData(JSON.parse(data));
    }
  }, []);

  useEffect(() => {
    if (location.search.includes('print=true') && previewData) {
      setTimeout(() => window.print(), 800);
    }
  }, [location, previewData]);

  const generateWhatsAppMessage = (data) => {
    const formData = data.formData;
    const currencySymbol = data.currencyOptions?.find(c => c.code === formData.Currency)?.symbol || '';
    
    let message = `🏝️ *${formData.Title || 'Package'}*\n`;
    message += `\n📝 ${formData.Description || 'No description'}\n`;
    message += `\n📅 Duration: ${formData.Duration || `${formData.TotalDays}D/${formData.TotalNights}N`}\n`;
    message += `📍 Destinations: ${formData.DestinationsCover || 'N/A'}\n`;
    message += `👥 Travelers: ${(formData.Adults || 0) + (formData.Kids || 0) + (formData.Infants || 0)}\n`;
    message += `💰 Price: ${currencySymbol}${formData.SalePrice || 0}\n`;
    message += `\n✈️ Travel Type: ${formData.TravelType || 'N/A'}\n`;

    
    if (formData.Itinerary && formData.Itinerary.length > 0) {
      message += `\n📋 *Itinerary:*\n`;
      formData.Itinerary.forEach((day, idx) => {
        message += `Day ${day.Day || idx + 1}: ${day.Title || ''}\n`;
        if (day.Description) message += `   ${day.Description}\n`;
        if (day.Location) message += `   📍 ${day.Location}\n`;
      });
    }
    
    if (formData.Inclusions && formData.Inclusions.length > 0) {
      message += `\n✅ *Inclusions:*\n`;
      formData.Inclusions.forEach(item => {
        message += `• ${item}\n`;
      });
    }
    
    if (formData.Exclusions && formData.Exclusions.length > 0) {
      message += `\n❌ *Exclusions:*\n`;
      formData.Exclusions.forEach(item => {
        message += `• ${item}\n`;
      });
    }
    
    message += `\n📞 *Contact:*\n`;
    message += `Name: ${formData.ContactName || 'N/A'}\n`;
    message += `Phone: ${formData.ContactPhoneNumber || 'N/A'}\n`;
    message += `Email: ${formData.ContactEmail || 'N/A'}\n`;
    
    return encodeURIComponent(message);
  };

  const handleShare = async () => {
    if (!previewData) return;
    
    try {
      if (navigator.share) {
        await navigator.share({
          title: previewData.formData.Title || 'Package',
          text: `Check out this package: ${previewData.formData.Title || ''}`,
          url: window.location.href,
        });
        return;
      }
    } catch (error) {
      console.log('Share cancelled or failed');
    }

    const message = generateWhatsAppMessage(previewData);
    const url = `https://web.whatsapp.com/send?text=${message}`;
    window.open(url, '_blank');
  };

  const handleDownloadPDF = async () => {
    if (!previewData || !previewRef.current) return;
    
    setIsDownloading(true);
    
    try {
      const canvas = await html2canvas(previewRef.current, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: previewRef.current.scrollWidth,
        height: previewRef.current.scrollHeight,
        windowWidth: previewRef.current.scrollWidth,
        windowHeight: previewRef.current.scrollHeight,
      });
      
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      
      let heightLeft = pdfHeight;
      let position = 0;
      
      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
      heightLeft -= pdf.internal.pageSize.getHeight();
      
      while (heightLeft > 0) {
        position = heightLeft - pdfHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
        heightLeft -= pdf.internal.pageSize.getHeight();
      }
      
      const fileName = `${previewData.formData.Title || 'package'}.pdf`;
      pdf.save(fileName);
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Error generating PDF. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  if (!previewData) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', flexDirection: 'column', gap: '16px' }}>
        <div style={{ fontSize: '40px' }}>📋</div>
        <div style={{ fontSize: '18px', color: '#6c757d' }}>Loading preview...</div>
        <div style={{ width: '32px', height: '32px', border: '3px solid #e9ecef', borderTop: '3px solid #667eea', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }}></div>
        <style>{`
          @keyframes spin { to { transform: rotate(360deg); } }
          @media print {
            .no-print { display: none !important; }
          }
        `}</style>
      </div>
    );
  }

  const selectedTemplateObj = templates.find(t => t.id === selectedTemplate);
  const TemplateComponent = selectedTemplateObj.component;

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Toolbar */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '20px',
        padding: '12px 20px',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        border: '1px solid #ddd',
        flexWrap: 'wrap',
        gap: '12px'
      }} className="no-print">
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
          <span style={{ fontWeight: '600', fontSize: '14px' }}>Template:</span>
          <select 
            value={selectedTemplate}
            onChange={(e) => setSelectedTemplate(Number(e.target.value))}
            style={{
              padding: '6px 12px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '13px',
              outline: 'none',
              backgroundColor: '#ffffff'
            }}
          >
            {templates.map(t => (
              <option key={t.id} value={t.id}>{t.name}</option>
            ))}
          </select>
        </div>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <button
            onClick={handleShare}
            style={{
              padding: '8px 16px',
              backgroundColor: '#25D366',
              color: '#ffffff',
              border: 'none',
              borderRadius: '4px',
              fontSize: '13px',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            💬 Share
          </button>
          <button
            onClick={handleDownloadPDF}
            disabled={isDownloading}
            style={{
              padding: '8px 16px',
              backgroundColor: isDownloading ? '#aaa' : '#000000',
              color: '#ffffff',
              border: 'none',
              borderRadius: '4px',
              fontSize: '13px',
              cursor: isDownloading ? 'not-allowed' : 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            {isDownloading ? '⏳ Generating...' : '📥 PDF'}
          </button>
          <button
            onClick={handlePrint}
            style={{
              padding: '8px 16px',
              backgroundColor: '#000000',
              color: '#ffffff',
              border: 'none',
              borderRadius: '4px',
              fontSize: '13px',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            🖨️ Print
          </button>
          <button
            onClick={() => window.close()}
            style={{
              padding: '8px 16px',
              backgroundColor: '#f1f3f5',
              color: '#495057',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '13px',
              cursor: 'pointer'
            }}
          >
            ✕ Close
          </button>
        </div>
      </div>

      {/* Template Display */}
      <div ref={previewRef}>
        <TemplateComponent 
          formData={previewData.formData}
          imagePreview={previewData.imagePreview}
          currencyOptions={previewData.currencyOptions}
        />
      </div>

      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { background: white !important; margin: 0 !important; padding: 0 !important; }
          * { color: black !important; }
        }
      `}</style>
    </div>
  );
};

export default PackagePreviewPage;